import { useEffect } from "react";
import { useGlobalPluginInfo } from "../../../../context/pluginInfoContext";
import { useFileStore } from "../../../../strore/useFileStore";

const LicenseJs = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store.licenseJs);
    const { pluginInfo, advancedItem } = useGlobalPluginInfo();
    const { pluginClassPrefix } = pluginInfo;
    const { mainClassName } = advancedItem;

    useEffect(() => {
        let value = `
jQuery(function($) {

    class ${mainClassName}_License_Manager {

        constructor($widget) {
            this.$widget = $widget;
            this.redirectTimer = 1500;
            this.setEvents();
        }

        setEvents() {

            const that = this;

            this.$widget.on('click', '.${pluginClassPrefix}-license-deactivate', function(e) {
                e.preventDefault();
                that.deactivate();
            });

            this.$widget.on('click', '.${pluginClassPrefix}-license-activate', function(e) {
                e.preventDefault();
                that.activate();
            });

        }

        deactivate() {

            var deactivate_action = this.$widget.find('input[name=deactivate_action]').val();
            var nonce = this.$widget.find('input[name=nonce]').val();
            this.$widget.find('.${pluginClassPrefix}-license-popup--notice').slideUp(100);
            this.$widget.find('.${pluginClassPrefix}-license--loader-wrapper').addClass('active');

            let data = {
                nonce: nonce,
                action: deactivate_action
            };

            jQuery.ajax({
                method: 'POST',
                url: ${mainClassName}_License_Manager_Vars.ajaxurl,
                data: data
            }).then((res) => {
                if (res.success && res.data.message) {
                    this.displayNotice(res.data.message, 'success');
                    this.$widget.removeClass('${pluginClassPrefix}-license-status--active');
                    setTimeout(function() {
                        window.location.reload();
                    }, this.redirectTimer);
                } else if (res.data.message) {
                    this.displayNotice(res.data.message, 'error');
                }
                this.$widget.find('.${pluginClassPrefix}-license--loader-wrapper').removeClass('active');
            }).catch((error) => {
                this.displayNotice(error, 'error');
                this.$widget.find('.${pluginClassPrefix}-license--loader-wrapper').removeClass('active');
            });
        }

        activate() {

            this.$widget.find('.${pluginClassPrefix}-license-popup--notice').slideUp(100);
            this.$widget.find('.${pluginClassPrefix}-license--loader-wrapper').addClass('active');

            let data = {
                license_key: this.$widget.find('.license_key').val(),
                nonce: this.$widget.find('input[name=nonce]').val(),
                action: this.$widget.find('input[name=activate_action]').val()
            }

            if (this.$widget.find('.product_id').length) {
                data.product_id = this.$widget.find('.product_id').val();
            }

            jQuery.ajax({
                method: 'POST',
                url: ${mainClassName}_License_Manager_Vars.ajaxurl,
                data: data
            }).then((res) => {
                if (res.success && res.data.message) {
                    this.displayNotice(res.data.message, 'success');
                    if (res.data.activated_text) this.$widget.find('.${pluginClassPrefix}-license-status td').text(res.data.activated_text);
                    this.$widget.addClass('${pluginClassPrefix}-license-status--active');
                    setTimeout(function() {
                        ${mainClassName}_License_Manager_Vars.redirect_url ? window.location = ${mainClassName}_License_Manager_Vars.redirect_url : window.location.reload();
                    }, this.redirectTimer);
                } else if (res.data.message) {
                    this.displayNotice(res.data.message, 'error');
                }
                this.$widget.find('.${pluginClassPrefix}-license--loader-wrapper').removeClass('active');
            }).catch((error) => {
                this.displayNotice(error, 'error');
                this.$widget.find('.${pluginClassPrefix}-license--loader-wrapper').removeClass('active');
            });

        }

        displayNotice(message, type) {
            if (!message) return;
            if (type == 'success') {
                this.$widget.find('.${pluginClassPrefix}-license-popup--notice').removeClass('${pluginClassPrefix}-license--notice-error').addClass('${pluginClassPrefix}-license--notice-success').html(message).slideDown(100);
            } else {
                this.$widget.find('.${pluginClassPrefix}-license-popup--notice').removeClass('${pluginClassPrefix}-license--notice-success').addClass('${pluginClassPrefix}-license--notice-error').html(message).slideDown(100);
            }
        }

    }

    // Initialize Popup
    $('.${pluginClassPrefix}-license-popup').each(function() {
        new ${mainClassName}_License_Manager($(this));
    });

    // Open Popup
    $('.${pluginClassPrefix}-lpt-btn').on('click', function(e) {
        e.preventDefault();
        $('#' + $(this).data('wc-popup-target')).find('.${pluginClassPrefix}-license-popup--wrapper').fadeIn(100);
    });

    // Close Popup
    $('.wc-licelse--close').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.${pluginClassPrefix}-license-popup--wrapper').fadeOut(100);
    });

});`;

        setStore({ licenseJs: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pluginClassPrefix, mainClassName]);
    return null;
};

export default LicenseJs;
